import { client } from './ApolloClient'
import ErrorTrackingAPI from '../ErrorTrackingAPI'
import { RETRIEVE_CAFE_CONFIG, RETRIEVE_MENUS, RETRIEVE_CAFE_CASH_REGISTERS, RETRIEVE_CAFE_GROUPS } from './schema'

const dashboardServices = {
    fetchMenus: async () => {
        try {
            return client
                .query({
                    query: RETRIEVE_MENUS,
                    variables: {
                        input: {
                            pagination: {
                                page: 1,
                                pageSize: 200,
                            },
                        },
                    },
                    fetchPolicy: 'network-only',
                })
                .then(res => {
                    return res.data.retrieveMenus
                })
                .catch(error => {
                    ErrorTrackingAPI.sendError(error, 'GraphqlAPI', 'fetchMenus', 'GraphQLError')
                    return { error }
                })
        } catch (error) {
            ErrorTrackingAPI.sendError(error, 'GraphqlAPI', 'fetchMenus', 'SystemError')
            return { error }
        }
    },

    fetchCafeConfig: async () => {
        try {
            return client
                .query({
                    query: RETRIEVE_CAFE_CONFIG,
                    fetchPolicy: 'network-only',
                })
                .then(res => {
                    return res.data.retrieveCafe
                })
                .catch(error => {
                    ErrorTrackingAPI.sendError(error, 'GraphqlAPI', 'fetchCafeConfig', 'GraphQLError')
                    return { error }
                })
        } catch (error) {
            ErrorTrackingAPI.sendError(error, 'GraphqlAPI', 'fetchCafeConfig', 'SystemError')
            return { error }
        }
    },

    fetchCafeCashRegisters: async () => {
        try {
            return client
                .query({
                    query: RETRIEVE_CAFE_CASH_REGISTERS,
                    fetchPolicy: 'network-only',
                })
                .then(res => {
                    return res.data.retrieveCafeCashRegisters
                })
                .catch(error => {
                    ErrorTrackingAPI.sendError(error, 'GraphqlAPI', 'fetchCafeCashRegisters', 'GraphQLError')
                    return { error }
                })
        } catch (error) {
            ErrorTrackingAPI.sendError(error, 'GraphqlAPI', 'fetchCafeCashRegisters', 'SystemError')
            return { error }
        }
    },

    fetchCafeGroups: async () => {
        try {
            return client
                .query({
                    query: RETRIEVE_CAFE_GROUPS,
                    fetchPolicy: 'network-only',
                })
                .then(res => {
                    return res.data.retrieveCafeGroups
                })
                .catch(error => {
                    ErrorTrackingAPI.sendError(error, 'GraphqlAPI', 'fetchCafeGroups', 'GraphQLError')
                    return { error }
                })
        } catch (error) {
            ErrorTrackingAPI.sendError(error, 'GraphqlAPI', 'fetchCafeGroups', 'SystemError')
            return { error }
        }
    },
}

export default dashboardServices
